import "./help.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import { getUrlParams } from "../../js/util";
import { post, get } from "../../js/http";

let accountTpl = require("./account/account.art"),
  angelTpl = require("./angel/angel.art"),
  faqTpl = require("./FAQ/FAQ.art"),
  methodTpl = require("./method/method.art"),
  comDocTpl = require("./comDoc/com-doc.art")

$(document).ready(function () {
  const personalActiveTab = getUrlParams("type");
  let docId = getUrlParams("order") || 0;
  switchTab(personalActiveTab);

  function switchTab(type) {
    layui.use(["element", "layer"], function () {
      var element = layui.element;
      switch (type) {
        case "faq":
          addTabActive(0);
          $("#help-content-wrap").html(faqTpl({}));
          break;
        case "angel":
          addTabActive(1);
          $("#help-content-wrap").html(angelTpl({}));
          break;
        case "method":
          addTabActive(2);
          $("#help-content-wrap").html(methodTpl({}));
          break;
        case "account":
          addTabActive(3);
          $("#help-content-wrap").html(accountTpl({}));
          break;
        case "com-doc":
          addTabActive(4);
          post("/ApiHome/ApiAction?_ControlName=GetSystemConfigAllByPC", {
            ParentID: 19600
          }).then(res => {
            res.ReturnStatus && res.Data && res.Data.OnlyOneData && (res.Data.OnlyOneData.length > 0) && (res.Data.OnlyOneData[docId].show = true) && $("#help-content-wrap").html(comDocTpl(res.Data))
            element.render("collapse");
          });
          break;
        default:
          addTabActive(0);
          $("#help-content-wrap").html(faqTpl({}));
          break;
      }
      element.render("collapse");
    });
  }
});

function addTabActive(key) {
  $(".help-l li").each((index, item) => {
    if (key == index) {
      $(item).addClass("active");
    } else {
      $(item).removeClass("active");
    }
  });
}
